<!-- https://xd.adobe.com/view/49c7325d-4e9a-44d9-b6f4-d9b577d64d3a-1c94/ -->
<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
<template>
  <div class="col-12 px2" v-if="showMobile && haaID !== '0'">
    <div class="clearfix border muted-border p2 pb3 mb2 shadow">
      <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 p2">
        <p class="h5 semi-bold darkblue line-height-2 mt3 mb2 gibson">
          Redigér i din profil-side på Håndværker.dk
        </p>
        <button target="_blank" @click="openUrl" class="xs-col-12 sm-col-12 md-col-7 lg-col-7 standard-button p2 flex justify-center items-center my3 border-none not-rounded">
          <span class="relative" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-arrow-square-up-right"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'/><path d='M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z'/></svg>
          </span>
          <span class="h4 gibson regular pl1 mb0">Se min profilside</span>
        </button>
        <p class="h5 regular darkblue line-height-golden gibson">
          Din profilside på Håndværker.dk er dit professionelle udstillingsvindue, som skaffer flere kunder. Profilsiden giver potentielle kunder sikkerhed for, at du og kunden er det perfekte match.
        </p>
        <!-- PartnerFriPartner -->
        <haandvaerker></haandvaerker>
        
        
        <p class="h5 regular darkblue line-height-golden gibson">
          Ville du vælge dig selv på baggrund af det, der vises på din profil i dag? Kan du præsenteres endnu bedre? Har du nye projekter du vil vise? Vi kan hjælpe dig i dag!
        </p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.
        </p>
      </div>
        <!-- information -->
        <el-collapse v-model="activeName" class="col-12 px2 gibson mb2 border-collapse" v-if="haaId !== '0'" accordion>
          <el-collapse-item name="1">
            <template slot="title">
              <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Informationer</p>
                <p class="h5 regular darkblue line-height-golden gibson">Disse er de informationer, som vil blive vist på din
                  profilside på Håndværker.dk.</p>
              </div>
            </template>
            <div class="py1"></div>
            <profilsideinformation :items="items" @clicked="SaveProfile"></profilsideinformation>
          </el-collapse-item>
        </el-collapse>
        <!-- TEXT -->
        <el-collapse v-model="activeName" v-b-toggle.profiletext class="col-12 px2 gibson mb2 border-collapse" accordion>
          <el-collapse-item name="2">
            <template slot="title">
              <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
                <p class="h5 regular darkblue line-height-golden gibson">
                  Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på
                  Google.
                </p>
              </div>
            </template>
            <div class="py1"></div>
            <div class=" flex col-12 justify-end p0 semi-bold ">
              <p class="darkblue m0">{{eliglbletextlimit}} Tekst</p>
            </div>
            <quill-editor ref="myQuillEditor" v-model="myHTML" :options="editorConfig" />
            <button class="action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson"
              @click="SaveDescription()">
              <span class="semi-bold">Gem ændringer</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
          </el-collapse-item>
        </el-collapse>
        <!-- Billeder -->
        <el-collapse v-model="activeName" v-b-toggle.collapse3 class="col-12 px2 gibson mb2 border-collapse" accordion>
          <el-collapse-item name="3">
            <template slot="title">
              <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilbilleder</p>
                <p class="h5 regular darkblue line-height-golden gibson">
                  Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver
                  kunderne et
                  godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre
                  mere.
                </p>
              </div>
            </template>
            <div class="py1"></div>
            <profileimages :images="images" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image"
              @edit_image="edit_image"></profileimages>
          </el-collapse-item>
        </el-collapse>
        <!-- video -->
        <el-collapse v-model="activeName" class="col-12 px2 gibson mb2 border-collapse" accordion>
          <el-collapse-item name="4">
            <template slot="title">
              <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilvideo</p>
                <p class="h5 regular darkblue line-height-golden gibson">
                  Upload en video til din profil. Video er det bedste medie til at give et godt indtryk.
                </p>
              </div>
            </template>
            <div class="py1"></div>
            <div @click="getdataigibility()" ref="picDisplay" id="profiletext">
              <profilevideo :videos="videos" @Reload="Reload" @delete_video="delete_video"></profilevideo>
            </div>
          </el-collapse-item>
        </el-collapse>
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson" v-if="haaId !== '0'">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Informationer</p>
        <p class="h5 regular darkblue line-height-golden gibson">Disse er de informationer, som vil blive vist på din profilside på Håndværker.dk.</p>
        <button v-b-toggle.collapse2 class="xs-col-12 sm-col-12 md-col-7 lg-col-7 outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h4 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
      </div> -->
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson">
        <b-collapse id="collapse2" class="mt-2">
          <profilsideinformation :items="items" @clicked="SaveProfile"></profilsideinformation>
        </b-collapse>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.
        </p>
        <button v-b-toggle.profiletext class="xs-col-12 sm-col-12 md-col-7 lg-col-7 outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h4 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
        <b-collapse ref="picDisplay" id="profiletext">
          <div class=" flex col-12 justify-end p0 semi-bold"><p class="darkblue m0">{{eliglbletextlimit}} Tekst</p></div>
          <quill-editor
            ref="myQuillEditor"
            v-model="myHTML"
            :options="editorConfig"

          />
          <button class="xs-col-12 sm-col-12 md-col-7 lg-col-7 action-button p2 h4 line-height-1 flex justify-center items-center my2 not-rounded gibson" @click="SaveDescription()">
            <span class="semi-bold">Gem ændringer</span>
            <span class="mx2"><i class="el-icon-right"></i></span>
          </button>
        </b-collapse>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilbilleder</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver kunderne et godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre mere.
        </p>
        <button v-b-toggle.collapse3 class="xs-col-12 sm-col-12 md-col-7 lg-col-7 outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h4 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
        <b-collapse ref="picDisplay" id="collapse3">
          <profileimages :images="images" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image" @edit_image="edit_image"></profileimages>
        </b-collapse>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilvideo</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Upload en video til din profil. Video er det bedste medie til at give et godt indtryk
        </p>
        <button v-b-toggle.collapse4 class="xs-col-12 sm-col-12 md-col-7 lg-col-7 outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h4 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
        <b-collapse ref="picDisplay" id="collapse4" class="my3 pt3">
          <profilevideo :videos="videos"  @Reload="Reload" @delete_video="delete_video" ></profilevideo>
        </b-collapse>
      </div> -->
    </div>
  </div>
  <div class="col-12 px2" v-if="!showMobile && haaId !== '0'">
    <div class="clearfix p2 pb3 mb2 ml4">
      <div class="col-12 p2">
        <div class="row">
          <div class="col-6">
            <p class="h4 semi-bold darkblue line-height-2 mt3 mb2 gibson">
              Redigér i din profil-side på Håndværker.dk
            </p>
          </div>
          <div class="col-6 flex justify-end">
              <button target="_blank" @click="openUrl" class="standard-button p2 flex justify-center items-center my3 border-none not-rounded">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-arrow-square-up-right"><path d='M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z'/><path d='M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z'/></svg>
                </span>
                <span class="h5 gibson regular pl1 mb0">Se min profilside</span>
              </button>
          </div>
        </div>
        <p class="h5 regular darkblue line-height-golden gibson">
          Din profilside på Håndværker.dk er dit professionelle udstillingsvindue, som skaffer flere kunder. Profilsiden giver potentielle kunder sikkerhed for, at du og kunden er det perfekte match.
        </p>
        <!-- PartnerFriPartner -->
        <haandvaerker></haandvaerker>
        <p class="h5 regular darkblue line-height-golden gibson">
          Ville du vælge dig selv på baggrund af det, der vises på din profil i dag? Kan du præsenteres endnu bedre? Har du nye projekter du vil vise? Vi kan hjælpe dig i dag! Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i
          løbet af 24 timer.
        </p>
        <!-- <p class="h5 regular darkblue line-height-golden gibson">
          Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.
        </p> -->
      </div>
      <!-- information -->
      <el-collapse v-model="activeName" class="col-12 px2 gibson mb2 border-collapse" v-if="haaId !== '0'" accordion>
        <el-collapse-item name="1"  >
          <template slot="title">
            <div class="flex flex-column items-start">
              <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Informationer</p>
              <p class="h5 regular darkblue line-height-golden gibson">Disse er de informationer, som vil blive vist på din profilside på Håndværker.dk.</p>
            </div>
          </template>
          <div class="py1"></div>
          <profilsideinformation :items="items" @clicked="SaveProfile"></profilsideinformation>
        </el-collapse-item>
      </el-collapse>
      <!-- TEXT -->
      <el-collapse v-model="activeName" v-b-toggle.profiletext  class="col-12 px2 gibson mb2 border-collapse" accordion>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="flex flex-column items-start">
              <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
              <p class="h5 regular darkblue line-height-golden gibson">
                Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.
              </p>
            </div>
          </template>
          <div class="py1"></div>
            <div class=" flex col-12 justify-end p0 semi-bold ">
              <p class="darkblue m0">{{eliglbletextlimit}} Tekst</p>
            </div>
            <quill-editor ref="myQuillEditor" v-model="myHTML" :options="editorConfig" />
            <button class="action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson"
              @click="SaveDescription()">
              <span class="semi-bold">Gem ændringer</span>
              <span class="mx2"><i class="el-icon-right"></i></span>
            </button>
        </el-collapse-item>
      </el-collapse>
      <!-- Billeder -->
      <el-collapse v-model="activeName" v-b-toggle.collapse3 class="col-12 px2 gibson mb2 border-collapse" accordion>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="flex flex-column items-start">
                <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilbilleder</p>
                <p class="h5 regular darkblue line-height-golden gibson">
                  Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver kunderne et
                  godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre mere.
                </p>
            </div>
          </template>
          <div class="py1"></div>
          <profileimages :images="images" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image"
            @edit_image="edit_image"></profileimages>
        </el-collapse-item>
      </el-collapse>
      <!-- video -->
      <el-collapse v-model="activeName" class="col-12 px2 gibson mb2 border-collapse" accordion>
        <el-collapse-item name="4">
          <template slot="title">
            <div class="flex flex-column items-start">
              <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilvideo</p>
              <p class="h5 regular darkblue line-height-golden gibson">
                Upload en video til din profil. Video er det bedste medie til at give et godt indtryk.
              </p>
            </div>
          </template>
          <div class="py1"></div>
            <div @click="getdataigibility()">
              <profilevideo :videos="videos" @Reload="Reload" @delete_video="delete_video"></profilevideo>
            </div>
        </el-collapse-item>
      </el-collapse>
      <!-- <div class="col-6 px2 gibson" v-if="haaId !== '0'">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Informationer</p>
        <p class="h5 regular darkblue line-height-golden gibson">Disse er de informationer, som vil blive vist på din profilside på Håndværker.dk.</p>
        <button v-b-toggle.collapse2 class="outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h5 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
      </div> -->
      <!-- <div class="col-6 px2 gibson">
        <b-collapse id="collapse2" class="mt-2">
          <profilsideinformation :items="items" @clicked="SaveProfile"></profilsideinformation>
        </b-collapse>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- Text -->
      <!-- <div class="col-6 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profiltekst</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.
        </p>
        <button v-b-toggle.profiletext class="outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h5 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
        <b-collapse ref="picDisplay" id="profiletext">
          <div class=" flex col-12 justify-end p0 semi-bold "><p class="darkblue m0">{{eliglbletextlimit}} Tekst</p></div>
          <quill-editor
            ref="myQuillEditor"
            v-model="myHTML"
            :options="editorConfig"
          />
          <button class="action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson" @click="SaveDescription()">
            <span class="semi-bold">Gem ændringer</span>
            <span class="mx2"><i class="el-icon-right"></i></span>
          </button>
        </b-collapse>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- Billeder -->
      <!-- <div class="col-6 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilbilleder</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver kunderne et godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre mere.
        </p>
        <button v-b-toggle.collapse3 class="outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h5 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
      </div> -->
      <!-- <div class="py1"></div> -->
      <!-- <b-collapse ref="picDisplay" id="collapse3">
        <profileimages :images="images" @moveImage="SaveImage" @Reload="Reload" @delete_image="delete_image" @edit_image="edit_image"></profileimages>
      </b-collapse> -->
      <!-- <div class="py1"></div> -->
      <!-- video -->
      <!-- <div class="xs-col-12 sm-col-12 md-col-8 lg-col-10 px2 gibson">
        <p class="h4 semi-bold darkblue line-height-4 gibson mt2">Profilvideo</p>
        <p class="h5 regular darkblue line-height-golden gibson">
          Upload en video til din profil. Video er det bedste medie til at give et godt indtryk. 
        </p>
        <button @click="getdataigibility()" class="outlined-action-button p2 flex justify-center items-center my3 not-rounded">
          <span class="h5 gibson semi-bold pl1 mb0">Rediger</span>
          <span class="relative ml2 when-closed" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
          <span class="relative ml2 when-opened" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </button>
        <b-collapse ref="picDisplay" id="collapse4" class="my3 pt3">
          <profilevideo :videos="videos"  @Reload="Reload" @delete_video="delete_video" ></profilevideo>
        </b-collapse>
      </div> -->
    </div>
  </div>
  <!-- overlay for basis member -->
  <div class="clearfix relative gibson px2 mb2 hide">
    <div class="absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2">
      <div>
        <p class="h4 gibson regular white line-height-golden">Som basismedlem har du desværre ikke adgang til denne del af partner-login.<br>
          Opgrader din løsning, hvis du vil have adgang.
        </p>
        <button class="p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1">
          <span>Kontakt mig</span>
          <span class="mx2"><i class="el-icon-right"></i></span>
        </button>
      </div>
    </div>
  </div>
</template>
    </div>
<b-modal id="modalPrevent" hide-footer v-model="modalShowBillede" title="Opdater billede" ref="modal" class="p-2 pb-4">
    </b-modal>
<div ref="containerImg">
    </div>
<div class="py4"></div>
<loading :show="show" :label="label" :overlay="overlay"></loading>
<simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
<noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </div>
</template>
<script>
import profilsideinformation from './Profilsideinformation'
import ratingWidget from './ratingWidget'
import commentWidget from './commentWidget'
import profileimages from './uploads/profileimages'
import profilevideo from './uploads/profilevideo'
import imagefolder from './uploads/imagefolder'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Haandvaerker from './haandvaerker'
import Slim from './../../slim/slim.module.js'
import VueQuillEditor from 'vue-quill-editor'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'ProfilSide',
  components: {
    Haandvaerker,
    ratingWidget,
    commentWidget,
    VueQuillEditor,
    Slim,
    profilsideinformation,
    profileimages,
    profilevideo,
    imagefolder,
    loading,
    Simplert,
    noneligibleFeaturepop
  },
  data () {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      FileLocation: '',
      instance: null,
      show: false,
      modalShowBillede: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      options: {
        hideModules: { 'link': true, 'code': true, 'justifyRight': true, 'justifyCenter': true, 'table': true, 'italic': true }
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        // The configuration of the editor.
      },
      slimOptions: {
        initialImage: this.FileLocation,
        service: this.slimService,
        didInit: this.slimInit,
        didConfirm: this.slimConfirm
      },
      haaId: '',
      imageId: '',
      items: [],
      videos: [],
      images: [],
      eligible: '',
      eliglbletextlimit: 'Ubegrænset',
      activeName: '',
      salesPersonbitrix: ''
    }
  },
  created () {
    this.eligible = localStorage.getItem('AccessVideoProProfile')
    this.eliglbletextlimit = localStorage.getItem('AccessDescriptionTextlimit') === null ? 'Ubegrænset' : localStorage.getItem('AccessDescriptionTextlimit')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1300) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.Reload()
  },
  methods: {
    getdataigibility () {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'AccessVideoProProfile')
      } else {
        this.$refs.picDisplay.show = true
      }
    },
    slimInit (data, slim) {
      console.log(slim)
      console.log(data)
      this.instance.edit()
      this.show = false
    },
    openUrl () {
      var win = window.open(this.items.url, '_blank')
      win.focus()
    },
    slimConfirm (data, slim) {
      console.log()
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'edit_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: this.imageId, image: this.instance.dataBase64.output.image}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    // called when upload button is pressed or automatically if push is enabled s
    slimService (formdata, progress, success, failure, slim) {
      console.log(slim)
      // set serviceFormat to "file" to receive an array of files
      console.log(formdata)
      console.log(progress, success, failure)
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.myHTML = res.Description
            this.images = res.resultImages
            this.videos = res.resultVideos
            this.ratingwidget = res.ratingwidget
            this.commentwidget = res.commentwidget
          },
          response => {
            alert('error')
          }
        )
    },
    SaveDescription () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_haa_desc', salesPerson: this.salesPerson, levid: this.haaId, description: this.myHTML}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.saveConfirmpermissionautomated()
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: 'Tak for opdateringen :)<br />' +
                  'Din tekst kommer online på din profil så snart den er godkendt.<br />' +
                  '<br />' +
                  'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    saveConfirmpermissionautomated () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      this.$http.get(this.$bitrixapi + 'external/AutomatedOnboardingApprovedByCraftman?LEV_ID=' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
        },
        (response) => {
        }
      )
    },
    SaveProfile () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_haa_profile', salesPerson: this.salesPerson, levid: this.haaId, items: this.items}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    edit_image (FileLocation, imageId) {
      this.imageId = imageId
      FileLocation = FileLocation.split('?')
      if (this.instance) {
        this.show = true
        this.img.src = FileLocation[0]
        this.instance = new Slim(this.$refs.containerImg, this.slimOptions)
      } else {
        this.show = true
        this.FileLocation = FileLocation[0]
        this.img = document.createElement('img')
        this.img.setAttribute('alt', '')
        this.img.src = FileLocation[0]
        this.$refs.containerImg.appendChild(this.img)
        this.instance = new Slim(this.$refs.containerImg, this.slimOptions)
      }
    },
    delete_video (videoId) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'delete_video', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            console.log('res', res)
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.videos = []
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    delete_image (imageId) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'delete_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    SaveImage (imageId, position) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'image_position', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId, position: position}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.images = res.resultImages
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
  // created () {
  //   this.$upload.new('profile-avatar', {
  //     onSuccess (res) {
  //       this.$msgbag.success('Avatar uploaded successfully.')
  //       this.$auth.user(res.data.data)
  //     },
  //     onError () {
  //       this.$msgbag.error('Error uploading avatar.')
  //     }
  //   })
  // },
  // mounted () {
  //   this.$upload.reset('profile-avatar', {
  //     url: `users/${this.$auth.user().id}/avatar`
  //   })
  // }
}
</script>
<style>
.el-collapse-item__header{
  height: 100% !important;
}
.border-collapse{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>



// WEBPACK FOOTER //
// Profilside.vue?71a011e7